export default __webpack_public_path__ + "static/media/composer@2x.db77d3f8.png";